import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Privacy } from "./components/privacy";
import { Term } from "./components/Term";
import { Contact } from "./components/contact";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});
const RemoveTrailingSlash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
  if (
    location.pathname !== "/" &&
    location.pathname.endsWith("/")
  ) {
    console.log("Redirecting from", location.pathname); // ← Add this
    navigate(location.pathname.slice(0, -1) + location.search, { replace: true });
  }
}, [location]);

  return null;
};
const AppContent = ({ landingPageData }) => {
  const location = useLocation(); 
  const excludedRoutes = ['/privacy', '/term'];

  return (
    <>
    <div> <Navigation /></div>
      {!excludedRoutes.includes(location.pathname) ? (
        <div>
         
          <Header data={landingPageData.Header} />
          <About data={landingPageData.About} />
          <Services data={landingPageData.Services} />
          <Contact data={landingPageData.Contact} />
        </div>
      ) : (
        <Routes>
          <Route path="/privacy" element={<Privacy data={landingPageData.Privacy} />} />
          <Route path="/term" element={<Term data={landingPageData.Term} />} />
        </Routes>
      )}
    </>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
       <RemoveTrailingSlash />
      <AppContent landingPageData={landingPageData} />
    </BrowserRouter>
  );
};

export default App;



